{
  "tabs": {
    "chat": "צ׳אט",
    "reminders": "תזכורות",
    "calendar": "לוח שנה",
    "settings": "הגדרות"
  },
  "common": {
    "cancel": "ביטול",
    "save": "שמור",
    "confirm": "אישור",
    "delete": "מחק",
    "back": "חזור",
    "close": "סגור",
    "edit": "ערוך",
    "search": "חפש",
    "all": "הכל",
    "loading": "טוען...",
    "error": "משהו השתבש",
    "notFound": "לא נמצא",
    "tryAgain": "נסה שוב",
    "retry": "נסה שוב",
    "undo": "בטל",
    "pullToRefresh": "משוך לרענון",
    "justNow": "הרגע"
  },
  "auth": {
    "welcome": "ברוכים הבאים ל-FishMemory",
    "tagline": "עוזר התזכורות שלך ב-WhatsApp, עכשיו בכיס שלך.",
    "subtitle": "עוזר התזכורות שלך ב-WhatsApp, עכשיו בכיס שלך.",
    "phoneLabel": "מספר ה-WhatsApp שלך",
    "phoneHint": "נשלח קוד אימות דרך WhatsApp",
    "invalidPhone": "אנא הזן מספר טלפון תקין",
    "continue": "המשך",
    "enterPhone": "הזן את מספר ה-WhatsApp שלך",
    "phonePlaceholder": "מספר טלפון",
    "sendCode": "שלח קוד",
    "verifyTitle": "אמת את המספר שלך",
    "otpSentTo": "קוד בן 6 ספרות נשלח ל-{{phone}} דרך WhatsApp",
    "enterFullCode": "אנא הזן את כל 6 הספרות",
    "invalidOtp": "קוד שגוי. נסה שוב.",
    "otpFailed": "שליחת הקוד נכשלה. נסה שוב.",
    "otpResent": "הקוד נשלח מחדש",
    "resendIn": "שלח שוב בעוד {{seconds}} שניות",
    "resendCode": "שלח קוד מחדש",
    "enterOtp": "הזן את הקוד שנשלח ל-WhatsApp שלך",
    "verify": "אמת",
    "resend": "שלח קוד מחדש",
    "wrongNumber": "מספר שגוי?",
    "backToPhone": "חזרה למספר",
    "editPhone": "ערוך מספר",
    "error": "שגיאה",
    "setupTitle": "בוא נתחיל",
    "setupSubtitle": "תוכל לשנות זאת בכל עת בהגדרות",
    "namePlaceholder": "שמך",
    "letsGo": "סיים הגדרה",
    "skipForNow": "דלג לעכשיו"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "הקלד הודעה...",
    "inputPlaceholder": "הקלד הודעה...",
    "typing": "FishMemory כותב...",
    "online": "מחובר",
    "connecting": "מתחבר...",
    "reconnecting": "מתחבר מחדש...",
    "offline": "מנותק",
    "empty": "התחל שיחה",
    "emptyHint": "צור תזכורות, בדוק את לוח הזמנים או בקש עזרה.",
    "emptyAction": "שלח תזכורת לדוגמה",
    "actions": "פעולות צ׳אט",
    "keep": "שמור הודעות",
    "clearTitle": "נקה צ׳אט",
    "clearConfirm": "למחוק את כל ההודעות מהמכשיר? לא ניתן לבטל.",
    "clear": "נקה צ׳אט",
    "optionSelected": "נבחר: {{label}}",
    "sendingSelection": "שולח...",
    "connectionLost": "מתחבר מחדש..."
  },
  "reminders": {
    "title": "התזכורות שלי",
    "active": "פעיל",
    "today": "היום",
    "thisWeek": "השבוע",
    "history": "היסטוריה",
    "items": "פריטים",
    "emptyTitle": "אין תזכורות עדיין",
    "emptySubtitle": "צור תזכורת בצ׳אט והיא תופיע כאן.",
    "emptyAction": "פתח צ׳אט",
    "filterActive": "פעיל",
    "filterToday": "היום",
    "filterWeek": "השבוע",
    "filterHistory": "היסטוריה",
    "emptyState": "אין תזכורות. התחל לשוחח!",
    "swipeDone": "בוצע",
    "swipeSnooze": "דחה",
    "swipeDelete": "מחק",
    "search": "חפש תזכורות...",
    "upcoming": "קרובות",
    "completed": "הושלם",
    "overdue": "מאחרות",
    "tomorrow": "מחר",
    "synced": "סונכרן {{value}}",
    "swipeHint": "גרור תזכורת לפעולות נוספות",
    "noResults": "אין תזכורות התואמות לחיפוש",
    "noResultsHint": "נסה מילה אחרת או נקה את החיפוש",
    "deleteAllFailed": "נכשל במחיקת כל התזכורות"
  },
  "calendar": {
    "title": "לוח שנה",
    "today": "היום",
    "tomorrow": "מחר",
    "completed": "בוצע",
    "noEvents": "אין אירועים",
    "noEventsSubtitle": "בחר תאריך כדי לראות תזכורות ואירועים.",
    "googleEvent": "Google Calendar",
    "legendActive": "פעיל",
    "legendRecurring": "חוזר",
    "legendDone": "בוצע",
    "legendGoogle": "Google",
    "previousMonth": "חודש קודם",
    "nextMonth": "חודש הבא",
    "previousYear": "שנה קודמת",
    "nextYear": "שנה הבאה",
    "goToToday": "לך להיום",
    "all": "הכל",
    "active": "פעיל",
    "done": "בוצע",
    "paused": "מושהה"
  },
  "settings": {
    "title": "הגדרות",
    "profile": "פרופיל",
    "name": "שם תצוגה",
    "enterName": "הזן את שמך",
    "language": "שפה",
    "uiLanguage": "שפת האפליקציה",
    "uiLanguageHelp": "משנה את שפת הממשק, תוויות לוח השנה וכיוון הפריסה במכשיר זה בלבד.",
    "serverLanguage": "שפת הצ׳אט",
    "serverLanguageHelp": "משנה את שפת התגובות מהשרת והודעות התזכורת בחשבונך.",
    "timezone": "אזור זמן",
    "currentTimezone": "אזור הזמן הנוכחי",
    "timezoneHelp": "כל זמני התזכורות מוצגים לפי אזור זמן זה.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "שמור אזור זמן",
    "timezoneSaved": "אזור הזמן עודכן",
    "detect": "גלה",
    "detectFailed": "לא ניתן לזהות אזור זמן",
    "autoDetect": "זיהוי אוטומטי מ-GPS",
    "notifications": "התראות",
    "notificationsHelp": "תזכורות המשך שולטות בהתראות חוזרות לאחר שליחת התזכורת. הרשאות התראות ברמת המכשיר מנוהלות בהגדרות הטלפון.",
    "pushEnabled": "התראות דחיפה",
    "autoDoneOnFire": "סמן אוטומטית כבוצע כשהתזכורת מופעלת",
    "autoDoneOnFireDesc": "כאשר כבוי, התזכורות נשארות פעילות עד לסימון כבוצעו.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "מחובר",
    "googleDisconnected": "לא מחובר",
    "googleConnectedHelp": "תזכורות חדשות יכולות להסתנכרן אוטומטית ללוח השנה שלך.",
    "googleDisconnectedHelp": "חבר את Google Calendar כדי לסנכרן תזכורות ואירועים.",
    "googleConnectFailed": "נכשל בחיבור ל-Google Calendar",
    "connected": "מחובר",
    "disconnected": "לא מחובר",
    "connect": "חבר",
    "disconnect": "נתק",
    "autoSync": "סנכרון אוטומטי לתזכורות חדשות",
    "autosync": "סנכרון אוטומטי לתזכורות חדשות",
    "subscription": "מנוי",
    "trialUsed": "ניסיון: {{used}}/{{total}} בשימוש",
    "trialStatus": "ניסיון זמין",
    "activeStatus": "מנוי פעיל",
    "expiredStatus": "המנוי פג תוקף",
    "unsubscribedStatus": "לא מנוי",
    "about": "אודות",
    "version": "גרסה",
    "logout": "התנתק",
    "logoutTitle": "התנתק",
    "logoutConfirm": "האם אתה בטוח שברצונך להתנתק?",
    "noName": "לא הוגדר שם",
    "serverConnection": "חיבור לשרת",
    "serverUrl": "כתובת שרת",
    "serverEdit": "ערוך",
    "saveReconnect": "שמור ותחבר מחדש",
    "resetDefault": "איפוס לברירת מחדל",
    "invalidServerUrlTitle": "כתובת שרת לא תקינה",
    "invalidServerUrlMessage": "הזן כתובת שרת http או https תקינה, לדוגמה https://example.com",
    "uiLanguageChangeFailed": "נכשל בשינוי שפת האפליקציה. נסה שוב.",
    "serverLanguageChangeFailed": "נכשל בשינוי שפת הצ׳אט. נסה שוב.",
    "timezoneChangeFailed": "נכשל בשינוי אזור הזמן. נסה שוב.",
    "autoSyncChangeFailed": "נכשל בעדכון הסנכרון האוטומטי. נסה שוב.",
    "nameChangeFailed": "נכשל בעדכון שם התצוגה. נסה שוב.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "פרטי התזכורת",
    "editTime": "ערוך זמן",
    "rename": "שנה שם",
    "snooze": "דחה",
    "snooze15": "דחה 15 דקות",
    "pause": "השהה",
    "pauseReminder": "השהה תזכורת",
    "resume": "המשך",
    "resumeReminder": "המשך תזכורת",
    "skip": "דלג הבא",
    "skipOccurrence": "דלג על מקרה זה",
    "syncGoogle": "סנכרן ל-Google",
    "delete": "מחק",
    "deleteTitle": "מחק תזכורת",
    "deleteConfirm": "תזכורת זו תימחק לצמיתות.",
    "deleteRecurringTitle": "מחק תזכורת חוזרת",
    "deleteRecurringMessage": "האם ברצונך לדלג על מקרה זה או למחוק את כל הסדרה?",
    "deleteThisOccurrence": "דלג על מקרה זה",
    "deleteEntireSeries": "מחק את כל הסדרה",
    "done": "בוצע",
    "markDone": "סמן כבוצע",
    "undo": "שחזר",
    "undoPrompt": "צריך אותה פעילה שוב? שחזר עכשיו.",
    "recurring": "חוזר",
    "nextRun": "הרצה הבאה",
    "oneTime": "חד פעמי",
    "pending": "ממתין",
    "sent": "נשלח",
    "paused": "מושהה",
    "active": "פעיל",
    "snoozed": "נדחה",
    "localTime": "מוצג לפי השעה המקומית שלך",
    "recurrence": "חזרה",
    "created": "נוצר",
    "tags": "תגיות",
    "fireCount": "מספר הפעלות",
    "actions": "פעולות",
    "none": "ללא",
    "snoozeFailed": "נכשל בדחיית התזכורת",
    "pauseFailed": "נכשל בהשהיית התזכורת",
    "resumeFailed": "נכשל בהמשך התזכורת",
    "skipFailed": "נכשל בדילוג על התזכורת",
    "doneFailed": "נכשל בסימון התזכורת כבוצעה",
    "undoFailed": "נכשל בשחזור מצב התזכורת",
    "deleteFailed": "נכשל במחיקת התזכורת",
    "rescheduleTitle": "לשנות מועד?",
    "rescheduleMsg": "התזכורת מאחרת. האם תרצה לשנות את המועד?",
    "reschedule15": "בעוד 15 דקות",
    "reschedule60": "בעוד שעה",
    "keepOverdue": "השאר כפי שהוא"
  },
  "onboarding": {
    "slide1Title": "ברוכים הבאים ל-FishMemory",
    "slide1Sub": "עוזר התזכורות האישי שלך — מופעל על ידי WhatsApp ונבנה לכיס שלך.",
    "slide2Title": "רק צ׳אט באופן טבעי",
    "slide2Sub": "הקלד תזכורות כפי שאתה חושב: \"תזכיר לי להתקשר לאמא מחר ב-15:00\" — אנחנו נטפל בשאר.",
    "slide3Title": "אל תפספס דבר",
    "slide3Sub": "קבל התראות בזמן, ארגן עם תגיות, ותישאר מעודכן בכל מה שחשוב.",
    "getStarted": "התחל",
    "next": "הבא",
    "firstReminderTitle": "צור את התזכורת הראשונה שלך!",
    "firstReminderHint": "נסה להקליד משהו כמו:",
    "firstReminderExample": "תזכיר לי לשתות מים מחר ב-9:00",
    "gotIt": "הבנתי!",
    "notifRationaleTitle": "תישאר בזמן",
    "notifRationaleBody": "FishMemory זקוק להתראות כדי להזכיר לך בזמן. תקבל התראות רק לתזכורות שיצרת.",
    "notifRationaleAllow": "אפשר התראות",
    "notifRationaleLater": "אולי מאוחר יותר",
    "swipeHint": "גרור ימינה לפעולות מהירות →",
    "calendarDragHint": "גרור להרחבה ↕"
  }
}
